import React, { useState, useEffect } from "react";
import HTMLReactParser from "html-react-parser";
import { useParams } from "react-router-dom";
import millify from "millify";
import { Col, Row, Typography, Select, Spin } from "antd";
import axios from "axios";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  Bar,
  BarChart,
} from "recharts";
import {
  MoneyCollectOutlined,
  DollarCircleOutlined,
  FundOutlined,
  ExclamationCircleOutlined,
  StopOutlined,
  TrophyOutlined,
  CheckOutlined,
  NumberOutlined,
  ThunderboltOutlined,
} from "@ant-design/icons";
import {
  useGetCryptoDetailsQuery,
  useGetCryptoHistoryQuery,
} from "../services/cryptoAPI";
import { coinList } from "../../src/dummyData";

const { Title, Text } = Typography;
const { Option } = Select;

const CryptoDetails = () => {
  const [coinId, setCoinId] = useState("");

  const { uuid } = useParams();
  const [timeperiod, setTimePeriod] = useState("1y");

  const { data: coinHistory } = useGetCryptoHistoryQuery({ uuid });

  const { data, isFetching } = useGetCryptoDetailsQuery(uuid);

  const [priceHistory, setpriceHistory] = useState([]);
  const [priceData, setpriceData] = useState([]);

  const HistoricalChart = (id, days = 365, currency) =>
    `https://api.coingecko.com/api/v3/coins/${id}/market_chart?vs_currency=${currency}&days=${days}`;

  async function getHistoricData(id44) {
    try {
      const response = await axios.get(
        HistoricalChart(id44, timeperiod, "inr")
      );
      // setCryptoList(response.data);
      console.log(response.data.prices);

      return response.data.prices;
    } catch (error) {
      console.error(error);
    }
  }

  let barchartData = [];

  useEffect(() => {
    const coinObj = coinList.filter(
      (item) =>
        item.symbol.toLowerCase() === data?.data?.coin.symbol.toLowerCase()
    );

    setCoinId(coinObj[0]?.id);
  }, [data?.data?.coin.symbol]);

  useEffect(() => {
    if (coinId) {
      console.log(coinId);
      const prices = getHistoricData(coinId, timeperiod);
      prices.then((response) => {
        setpriceHistory(response);
      });

      console.log(priceHistory, "priceHistory");
    }
  }, [coinId, timeperiod]);

  //wait 2 seconds

  useEffect(() => {
    coinHistory?.data?.history?.map((item) => {
      let obj = {
        time: new Date(item.timestamp * 1000).toLocaleDateString(),
        price: item.price,
      };
      barchartData.push(obj);
    });
  });
  useEffect(() => {
    const priceArray = [];
    priceHistory?.map((item) => {
      const priceObj = {
        time: new Date(item[0]).toLocaleDateString(),
        price: item[1],
      };
      priceArray.push(priceObj);
    });
    setpriceData(priceArray);
  }, [priceHistory]);

  if (isFetching)
    return (
      <div className="spin">
        <Spin size="large" />
      </div>
    );

  const cryptoDetails = data?.data?.coin;

  const time = ["1", "30", "90", "365"];

  const stats = [
    {
      title: "Price to USD",
      value: `$ ${cryptoDetails?.price && millify(cryptoDetails?.price)}`,
      icon: <DollarCircleOutlined />,
    },
    { title: "Rank", value: cryptoDetails?.rank, icon: <NumberOutlined /> },
    {
      title: "24h Volume",
      value: `$ ${cryptoDetails?.volume && millify(cryptoDetails?.volume)}`,
      icon: <ThunderboltOutlined />,
    },
    {
      title: "Market Cap",
      value: `$ ${
        cryptoDetails?.marketCap && millify(cryptoDetails?.marketCap)
      }`,
      icon: <DollarCircleOutlined />,
    },
    {
      title: "All-time-high(daily avg.)",
      value: `$ ${
        cryptoDetails?.allTimeHigh?.price &&
        millify(cryptoDetails?.allTimeHigh?.price)
      }`,
      icon: <TrophyOutlined />,
    },
  ];

  const genericStats = [
    {
      title: "Number Of Markets",
      value: cryptoDetails?.numberOfMarkets,
      icon: <FundOutlined />,
    },
    {
      title: "Number Of Exchanges",
      value: cryptoDetails?.numberOfExchanges,
      icon: <MoneyCollectOutlined />,
    },
    {
      title: "Aprroved Supply",
      value: cryptoDetails?.supply?.confirmed ? (
        <CheckOutlined />
      ) : (
        <StopOutlined />
      ),
      icon: <ExclamationCircleOutlined />,
    },
    {
      title: "Total Supply",
      value: `$ ${
        cryptoDetails?.supply?.total && millify(cryptoDetails?.supply?.total)
      }`,
      icon: <ExclamationCircleOutlined />,
    },
    {
      title: "Circulating Supply",
      value: `$ ${
        cryptoDetails?.supply?.circulating &&
        millify(cryptoDetails?.supply?.circulating)
      }`,
      icon: <ExclamationCircleOutlined />,
    },
  ];

  return (
    <>
      <Col className="coin-detail-container">
        <Col className="coin-heading-container">
          <Title level={2} className="coin-name">
            {data?.data?.coin.name} ({data?.data?.coin.symbol}) Price
          </Title>
          <p>
            {cryptoDetails?.name} live price in US Dollar (USD). View value
            statistics, market cap and supply.
          </p>
        </Col>
        <Select
          defaultValue="365"
          className="select no of Days"
          placeholder="Select number of days"
          onChange={(value) => setTimePeriod(value)}
        >
          {time.map((date) => (
            <Option key={date}>{date}</Option>
          ))}
        </Select>

        <ResponsiveContainer width="100%" aspect={3}>
          <BarChart
            width={500}
            height={300}
            data={priceData}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <XAxis dataKey="time" />

            <Tooltip />
            <Legend />
            <Bar dataKey="price" fill="#5B4B8A" />
          </BarChart>
        </ResponsiveContainer>
        <Col className="stats-container">
          <Col className="coin-value-statistics">
            <Col className="coin-value-statistics-heading">
              <Title level={3} className="coin-details-heading">
                {cryptoDetails?.name} Value Statistics
              </Title>
              <p>
                An overview showing the statistics of {cryptoDetails?.name},
                such as the base and quote currency, the rank, and trading
                volume.
              </p>
            </Col>
            {stats.map(({ icon, title, value }) => (
              <Col className="coin-stats">
                <Col className="coin-stats-name">
                  <Text>{icon}</Text>
                  <Text>{title}</Text>
                </Col>
                <Text className="stats">{value}</Text>
              </Col>
            ))}
          </Col>
          <Col className="other-stats-info">
            <Col className="coin-value-statistics-heading">
              <Title level={3} className="coin-details-heading">
                Other Stats Info
              </Title>
              <p>
                An overview showing the statistics of {cryptoDetails?.name},
                such as the base and quote currency, the rank, and trading
                volume.
              </p>
            </Col>
            {genericStats.map(({ icon, title, value }) => (
              <Col className="coin-stats">
                <Col className="coin-stats-name">
                  <Text>{icon}</Text>
                  <Text>{title}</Text>
                </Col>
                <Text className="stats">{value}</Text>
              </Col>
            ))}
          </Col>
        </Col>
        <Col className="coin-desc-link">
          <Row className="coin-desc">
            <Title level={3} className="coin-details-heading">
              What is {cryptoDetails?.name}?
            </Title>
            {HTMLReactParser(cryptoDetails?.description)}
          </Row>
          <Col className="coin-links">
            <Title level={3} className="coin-details-heading">
              {cryptoDetails?.name} Links
            </Title>
            {cryptoDetails?.links?.map((link) => (
              <Row className="coin-link" key={link.name}>
                <Title level={5} className="link-name">
                  {link.type}
                </Title>
                <a href={link.url} target="_blank" rel="noreferrer">
                  {link.name}
                </a>
              </Row>
            ))}
          </Col>
        </Col>
      </Col>
    </>
  );
};

export default CryptoDetails;
